import texts from './categorycard4.texts'

class Categorycard4Controller {
    constructor() {
        this.name = 'categorycard4'
    }

    $onInit() {
        this.title = this.data.category
        this.description = texts[this.title]
    }
}

export default Categorycard4Controller



// WEBPACK FOOTER //
// ./client/app/components/home/book/step3/categorycard4/categorycard4.controller.js